<template>
    <v-container fluid>
        <v-card>
            <v-card-title class="d-flex justify-space-between">
                <span>Curriculum Kit 2 Amount Configuration</span>
                <v-btn
                  :to="{
                    name: 'amountconfiguration',
                  }"
                  v-if="!modules.isChecker && !isSuperAdmin"
                  class="mr-2"
                  small
                  dense
                  color="accent"
                >
                  Configure Curriculum Kit 2 amount
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :footer-props="{
                        'items-per-page-options': [5, 10, 20, 40]
                    }"
                    :items-per-page="10"
                    :headers="headers"
                    :items="curriculumKit2List"
                    :search.sync="search"
                    >
                    <template v-slot:item.status="{ item }">
                        <div :class="item.class" style="text-transform: uppercase;">
                        {{ item.status }}
                        </div>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div v-if="!modules.isChecker && !isSuperAdmin">
                          <v-btn
                            :to="{ name: 'editamountconfiguration', params: { id: item.id ,edit:'edit' } }"
                            class="px-2 ml-1 white--text ma-1"
                            color="success"
                            small
                            icon
                            :disabled="item.status !== 'rejected'"
                          >
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                        </div>
                        <div v-else-if="modules.isChecker && !isSuperAdmin">
                          <v-btn
                            class="px-2 ml-1 white--text ma-1"
                            color="success"
                            small
                            dense
                            outlined
                            elevation="0"
                            :disabled="!(item.status === 'pending')"
                            @click="approveCurriculumKit2AmountConfiguration(item.id)"
                          >
                            Approve
                          </v-btn>
                          <v-btn
                            class="px-2 ml-1 white--text ma-1"
                            color="error"
                            small
                            dense
                            outlined
                            elevation="0"
                            @click="openRejectPopup(item.id)"
                            :disabled="!(item.status === 'pending')"
                          >
                            Reject
                          </v-btn>
                        </div>
                        <div v-else class="text-left">
                          <span>-</span>
                        </div>
                    </template>
                    <template v-slot:no-data>
                        <v-card-subtitle class="d-flex justify-center"
                        >No Data Available</v-card-subtitle
                        >
                    </template>
                    </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog v-model="rejectDialog" max-width="500px">
          <v-card>
            <v-toolbar dark color="accent" dense elevation="0">
              <v-toolbar-title> Reject Curriculum Kit 2 amount configuration? </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-textarea
                counter="500"
                auto-grow
                v-model="rejectReason"
                maxlength="500"
              >
                <template v-slot:label>
                  Reason of Rejection <span class="error--text">*</span>
                </template>
              </v-textarea>
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
              <v-btn color="primary" text @click="closeRejectPopup(), dialog = false">
                Cancel
              </v-btn>
              <v-btn :disabled='!rejectReason' color="error" text @click="rejectWowKit2AmountConfiguration()">
                Reject
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-container>
  </template>

<script>
import CONSTANTS from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Utils from '@/utils'
export default {
  components: { },
  name: 'CityStateList',
  data () {
    return {
      isSuperAdmin: false,
      enablePagination: false,
      curriculumKit2List: [],
      endPoints: [],
      loadingComponent: null,
      myloadingvariable: false,
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        { text: 'Acadmemic Year', value: 'academicYear', sortable: true },
        { text: 'Zone', value: 'zone', sortable: true },
        { text: 'Amount', value: 'amount', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Created By', value: 'createdBy', sortable: false },
        { text: 'Date', value: 'createdAt', sortable: false },
        { text: 'Action', value: 'action', sortable: false }
      ],
      modules: {
        isChecker: this.checkModuleAccess('isCurriculumKit2Checker')
      },
      rejectReason: null,
      rejectDialog: false,
      rejectId: null
    }
  },
  computed: {
    ...mapGetters({
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    // academicYear: async function (newVal, oldVal) {
    //   if (newVal.id) {
    //     await this.getCurriculumKit2AmountConfiguration()
    //   }
    // }
  },
  async created () {
    this.isSuperAdmin = await Utils.helper.isSuperAdmin()
    await this.getCurriculumKit2AmountConfiguration()
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getCurriculumKit2AmountConfiguration: async function () {
      try {
        this.curriculumKit2List = []
        let res = await http.post(`${CONSTANTS.API_URL}/api/kit2/get-kit2-configuration`, { academicYearId: '' })
        if (res.status === 200 && res.data.length > 0) {
          res.data.forEach(item => {
            let obj = {}
            obj.id = item.id
            obj.academicYear = item.franchiseeAcademicYear.academicYear || '-'
            obj.zone = item.zone.name || '-'
            obj.amount = item.amount.toFixed(2)
            obj.status = item.status || '-'
            obj.class = this.getColor(item.status)
            obj.createdBy = item.createdBy || '-'
            obj.createdAt = moment(item.createdAt).format('YYYY-MM-DD')
            this.curriculumKit2List.push(obj)
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getColor (status) {
      if (status === 'approved') return 'v-green font-weight-medium'
      else if (status === 'rejected') return 'v-error font-weight-medium'
      else if (status === 'pending') return 'v-warning font-weight-medium'
      else return 'v-secondary '
    },
    approveCurriculumKit2AmountConfiguration: function (rowId) {
      this.$dialog.confirm({
        title: 'Approve Curriculum Kit 2 amount?',
        text: 'Are you sure you want to <b>approve</b> Curriculum Kit 2 amount configuration?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                let payload = {
                  'id': rowId,
                  'status': 'approved',
                  'remark': ''
                }
                let res = await http.post(`${CONSTANTS.API_URL}/api/kit2/update-kit2-configuration-status`, payload)
                if (res.status === 200) {
                  this.okMsg(res.data.message)
                  this.getCurriculumKit2AmountConfiguration()
                } else {
                  this.errMsg(res.data.message)
                }
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              }
            }
          }
        }
      })
    },
    openRejectPopup (rowID) {
      this.rejectDialog = true
      this.rejectId = rowID
    },
    closeRejectPopup () {
      this.rejectId = null
      this.rejectReason = null
      this.rejectDialog = false
    },
    async rejectWowKit2AmountConfiguration () {
      try {
        if (!this.rejectReason.trim()) {
          this.errMsg('Please provide reason of rejection.')
          return
        }
        let payload = {
          'id': this.rejectId,
          'status': 'rejected',
          'remark': this.rejectReason
        }
        let res = await http.post(`${CONSTANTS.API_URL}/api/kit2/update-kit2-configuration-status`, payload)
        if (res.status === 200) {
          this.okMsg(res.data.message)
          this.closeRejectPopup()
          this.getCurriculumKit2AmountConfiguration()
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
